import { adminQueryKeys as e } from "./adminQueryKeys.mjs";
import { useHasAdminSession as t } from "./adminSessionFlag.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/queries/admin/useAdminMeQuery.ts
var i = () => {
	let i = t();
	return n({
		queryKey: e.me(),
		queryFn: r.adminMe,
		enabled: i,
		retry: !1,
		staleTime: 300 * 1e3,
		refetchOnWindowFocus: !1
	});
};
//#endregion
export { i as useAdminMeQuery };
